export class Queue<T> {
  private items: T[] = [];

  /**
   * Add an element to the queue
   * @param element Element to add
   */
  enqueue(element: T): void {
    this.items.push(element);
  }

  /**
   * Remove and return an element from the queue
   * @returns Removed element or undefined if the queue is empty
   */
  dequeue(): T | undefined {
    if (this.isEmpty()) {
      return undefined;
    }
    return this.items.shift();
  }

  /**
   * Return the front element of the queue without removing it
   * @returns Front element of the queue or undefined if the queue is empty
   */
  peek(): T | undefined {
    if (this.isEmpty()) {
      return undefined;
    }
    return this.items[0];
  }

  /**
   * Check if the queue is empty
   * @returns true if the queue is empty, false otherwise
   */
  isEmpty(): boolean {
    return this.items.length === 0;
  }

  /**
   * Return the size of the queue
   * @returns Number of elements in the queue
   */
  size(): number {
    return this.items.length;
  }

  /**
   * Clear the queue
   */
  clear(): void {
    this.items = [];
  }

  /**
   * Return the contents of the queue as a string
   * @returns String representation of the queue contents
   */
  toString(): string {
    return this.items.toString();
  }
}
